/**
 * return token form sessionStorage
 * @returns
 */

import { decryptData } from '@/components/reusable/crypto/Cipher';
import Cookies from 'js-cookie';

const useToken = () => {
  try {
    const role = Cookies.get('role');
    // const token = Cookies.get(`${role !== 'user' ? role + '_' : ''}token`);
    const token = Cookies.get('token');
    if (!token) return null;
    return decryptData(token);
  } catch (error) {
    throw new Error(error);
  }
};

export default useToken;
